import $ from "jquery";
import slickInit from './modules/slick/slick';
import geoDealers from './modules/geolocation';

// Init Geolocation
function initGoogleMaps() {
    // create instance
    if (!window.geo) {
        window.geo = new geoDealers();
    }
}

// Expose function globally for Google Maps callback
window.initGoogleMaps = initGoogleMaps;

$(document).ready(function(){
    slickInit();

    // Admin toolbar fix
    if ($('#wpadminbar')[0])
        $('header, .top-banner, html').addClass('wpadminbar-active');

    // Add smooth scrolling to all links
    $("a[href^='#']").on('click', function(event) {

        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "" && typeof this.hash !== 'undefined') {
          // Prevent default anchor click behavior
          event.preventDefault();

          // Store hash
            var hash = this.hash;
            var scrollTo = $(hash).offset().top - 150;
            $('html, body').animate({
                scrollTop: scrollTo
            }, 800, function(){

          });
        } // End if
    });

    $('html').on('click', (e) => {
        var container = $('.menu-item-has-children > a');

        // If the click is NOT on a menu item or its children
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            // Close visual state
            $('.menu-item-has-children > a, .icon-drop-down').removeClass('is-open');
            $('.sub-menu').slideUp().attr('aria-hidden', 'true');

            // Reset aria-expanded on all menu items
            $('.menu-item-has-children > a').attr('aria-expanded', 'false');
        }
    });

    // Main menu toggle
    $('.js-primary-menu').on('click', function(e) {
        e.preventDefault();

        // Menu functions
        $('.primary-menu').toggleClass('is-open');

        if ($(this).hasClass('menu-open')) {
            $('body').removeClass('menu-open');
            $(this).attr('aria-expanded', 'false');
        } else {
            $('body').addClass('menu-open');
            $(this).attr('aria-expanded', 'true');
        }

        $(this).toggleClass('menu-open');

        if ($('.site-header').hasClass('scroll')) {
            $('.site-header').removeClass('scroll');
        }

        if (!$(this).hasClass('menu-open') && ($(document).scrollTop() > 200)) {
            $('.site-header').addClass('scroll');
        }
    });

    // Submenu toggle
    $('.menu-item-has-children > a').on('click', function(e) {
        e.preventDefault();

        var thisMenu  = $(this).siblings('.sub-menu');
        var thisArrow = $(this).find('.icon-drop-down');

        // Close all other submenus
        $('.sub-menu').not(thisMenu).slideUp().attr('aria-hidden', 'true');
        $('.icon-drop-down').not(thisArrow).removeClass('is-open');
        $('.primary-menu-nav .menu-item-has-children > a')
            .not($(this))
            .removeClass('is-open')
            .attr('aria-expanded', 'false');

        // Toggle current submenu
        thisMenu.slideToggle();

        // Toggle aria-expanded on the current link
        var expanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !expanded);

        // Toggle aria-hidden on submenu
        thisMenu.attr('aria-hidden', expanded);

        // Toggle arrow state
        thisArrow.toggleClass('is-open');
        $(this).toggleClass('is-open');
    });

    if ($('.current-category').length > 0) {
        // Remove old selected clone if exists
        $('.current-category.selected').remove();

        // Clone current category into widget
        $('li.current-category')
            .clone()
            .prependTo('.categories.widget .cat-links')
            .addClass('selected')
            .attr({
                'role': 'button',
                'tabindex': '0',
                'aria-expanded': 'false',
            })
            .find('.children')
            .remove();
    }

    // Toggle on click
    $('.current-category.selected').on('click keypress', function (e) {
        // Handle Enter or Space key as well as click
        if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();

            let $this = $(this);
            let expanded = $this.attr('aria-expanded') === 'true';

            $this.toggleClass('open');
            $this.attr('aria-expanded', !expanded);

            // Toggle sibling categories visibility
            let siblings = $this.siblings();
            siblings.slideToggle();
            siblings.attr('aria-hidden', expanded);
        }
    });


    $(window).on('scroll', function() {
        var scroll = $(window).scrollTop();
        var scrollVal = 120;

        if ($(window).width() <= 1024) {
            scrollVal = 60;
        }

        if (scroll >= scrollVal) {
            $(".site-header").addClass("is-sticky");
        } else {
            $(".site-header").removeClass("is-sticky");
        }
    });

     // Open all external links in a new window
     $("a[href^=http]").click(function(){
       if(this.href.indexOf(location.hostname) == -1) {
          $(this).attr({
             target: "_blank",
             title: "Opens in a new window"
          });
       }
    });

    // Social Popup
    $(".popup").click(function(event) {
      var width = 575,
        height = 400,
        left = ($(window).width() - width) / 2,
        top = ($(window).height() - height) / 2,
        url = this.href,
        opts =
          "status=1" +
          ",width=" +
          width +
          ",height=" +
          height +
          ",top=" +
          top +
          ",left=" +
          left;

      window.open(url, "twitter", opts);
      return false;
    });

    $(document).on('change', '.geolocation', function() {
        if (window.geo.runGeo) {
            var userAddress = $('.geolocation').val();
            if ($('.geolocation').val() != localStorage.getItem('userAddress')) {

                if ($('.product-request-quote').length) {
                    $('#dealer-results').empty().prepend('<p class ="dealers-message">Please wait, loading...</p>');
                    $('#dealer-more-info .more-info-content').empty();
                    // Convert address to coordinates and loadDealers (true), set false to just convert
                    window.geo.geocodeUserAddress(userAddress, true);
                } else {
                    window.geo.geocodeUserAddress(userAddress, false);
                }
                
            }
        }
        window.geo.runGeo = true;
    });

    

    // Multipart change part - Request quote
    // TODO: Check the console for errors - remove if statement if not working
    if(typeof Marionette !== 'undefined') {
        nfRadio.channel( 'nfMP' ).on('change:part', function() {
            if ($('.geolocation').length > 0) {
                console.log('step: geo found');
                var userAddress = $('.geolocation').val() != '' ? $('.geolocation').val() : localStorage.getItem('userAddress');
                geo.initGeo(userAddress);
            }

            var submitBtn = $('.nf-next-previous').parents('.nf-mp-footer').siblings('.nf-mp-body').find('.submit-container');
            var prevBtn = submitBtn.parents('.nf-mp-body').siblings('.nf-mp-footer').find('.nf-next-previous');

            if (submitBtn.length > 0 ) {
                
                prevBtn.append('<li class="nf-submit-next"></li>');
                submitBtn.appendTo('.nf-submit-next');
            }

        });
    }

    // Single Porduct Template - Load Dealers
    $('body').on('click', '.clickable', function(e) {
        const $errorField = $('.nf-field:has(#dealer-results)');

        $errorField.removeClass('nf-error');
        $errorField.find('.nf-error-msg').remove();
        $('.product-request-quote .nf-next').prop('disabled', false);

        $('.clickable').removeClass('focused');

        const $target = $(e.currentTarget); // safest reference
        $target.addClass('focused');

        const email = $target.attr('data-email');   // or .data('email') if you're using jQuery's data
        const name = $target.attr('data-name');

        const dealerEmail = $('#request-quote input[data-key="dealeremail"]');
        const dealerName = $('#request-quote input[data-key="dealername"]');

        if (dealerEmail.length) {
            dispatchEvents(dealerEmail, dealerName, email, name);
        }
    });


    // Find a Dealer page - on "Search" button click
    $( document ).on('click', ".find-dealer-submit", function() { 
        var userAddress = $('.geolocation').val();
        // Add message to wait
        $('#dealer-results').empty().prepend('<p class ="dealers-message">Please wait, loading...</p>');
        $('#dealer-more-info .more-info-content').empty();
        // Convert address to coordinates and loadDealers (true), set false to just convert
        geo.geocodeUserAddress(userAddress, true);
    
    });

    $(document).on('click', '.request-quote-button', function(e) {
        e.preventDefault();
        $('.modal').fadeOut();

        var email = $(e.currentTarget).attr('data-email');   
        var name = $(e.currentTarget).attr('data-name'); 

        $(".find-dealer-rq").fadeIn();
        resetNinjaForm();

        $(document).one( 'click', '.find-dealer-rq input.ninja-forms-field', function() {

            var dealerEmail = $('.find-dealer-rq input[data-key="dealeremail"]');
            var dealerName = $('.find-dealer-rq input[data-key="dealername"]');

            if (dealerEmail.length) {
                dispatchEvents(dealerEmail, dealerName, email, name);
            }
            
        });
    });

    function dispatchEvents(dealerEmail, dealerName, email, name) {
        dealerEmail.val(email).trigger( 'change' );
        dealerName.val(name).trigger( 'change' );
        // trigger event change the hard way - no other way works
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", true, true);
        dealerEmail[0].dispatchEvent(evt);
        dealerName[0].dispatchEvent(evt);
        console.log(dealerName.val());
    }

    // Create a global cache for reCAPTCHA widget IDs (optional)
    window.recaptchaWidgets = window.recaptchaWidgets || {};

    // Function to reset the Ninja Form
    function resetNinjaForm() {
        // Target the Ninja Form container
        const $formContainer = $('.find-dealer-rq .nf-form-cont');
        if ($formContainer.length !== 1) {
            console.error('Expected exactly one .nf-form-cont element, found:', $formContainer.length);
            return;
        }
        const containerID = '#' + $formContainer.attr('id');
        const $form = $formContainer.find('form');

        // Reset the form fields
        if ($form.length && $form[0]) {
            $form[0].reset();
        } else {
            console.warn('No form found in container:', containerID);
        }

        // Show the form again
        $formContainer.find('.nf-form-wrap, form').show();

        // Hide the success message
        $formContainer.find('.nf-response-msg').hide();

        // Function to handle reCAPTCHA reset/render
        function handleRecaptcha() {
            if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render === 'function') {
                $formContainer.find('.g-recaptcha').each(function (index, el) {
                    // Ensure element has a unique ID
                    if (!el.id) {
                        el.id = `recaptcha-${index}`;
                    }

                    // Check if a widget is already rendered
                    const isRendered = el.hasAttribute('data-widget-id') || !!$(el).find('.g-recaptcha-response').length;

                    if (isRendered) {
                        // Reset existing widget
                        const widgetId = el.getAttribute('data-widget-id');
                        if (widgetId && grecaptcha.getResponse(widgetId) !== undefined) {
                            grecaptcha.reset(widgetId);
                        }
                    } else {
                        // Render new widget and store widget ID
                        const siteKey = el.getAttribute('data-sitekey');
                        if (!siteKey) {
                            console.error(`No data-sitekey found for reCAPTCHA element: ${el.id}`);
                            return;
                        }
                        const widgetId = grecaptcha.render(el, { sitekey: siteKey });
                        el.setAttribute('data-widget-id', widgetId);
                        window.recaptchaWidgets[el.id] = widgetId; // Store in global cache
                    }
                });
            } else {
                console.warn('grecaptcha not yet ready');
            }
        }

        // Wait for reCAPTCHA to be ready
        function waitForRecaptcha(callback, attempts = 10, interval = 300) {
            if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render === 'function') {
                callback();
            } else if (attempts > 0) {
                setTimeout(() => waitForRecaptcha(callback, attempts - 1, interval), interval);
            } else {
                console.error('grecaptcha failed to load after multiple attempts');
                // Optionally notify user, e.g., show an error message on the form
                $formContainer.append('<div class="error">Failed to load reCAPTCHA. Please refresh the page.</div>');
            }
        }

        // Execute reCAPTCHA handling
        waitForRecaptcha(handleRecaptcha);

        // Reinitialize Ninja Forms frontend
        if (typeof window.nfFrontEnd !== 'undefined') {
            $(document).trigger('nfFormReady');
        } else {
            console.error('Ninja Forms frontend scripts are not loaded.');
            // Optionally notify user
            $formContainer.append('<div class="error">Form functionality may be limited. Please refresh the page.</div>');
        }
    }

    $(document).on('click', '.close', function() {
        $(this).parent().fadeOut();
    }); 

    $(document).on('click', function(e) {
        const $modal = $('#dealer-more-info');

        // Only proceed if this modal is visible
        if ($modal.is(':visible') && !$(e.target).closest('#dealer-more-info .modal-content').length) {
            $modal.fadeOut();
        }
    });

    $(document).on('click', '.click-reveal:not(.revealed)', function (e) {
        e.preventDefault();
        var reveal = $(this).data('reveal');
        $(this).find('span').text(reveal);
        $(this).addClass('revealed');
    }); 

    $(document).on('click', '.dealer-more-info', function(e) {
        e.preventDefault();
        e.stopPropagation(); // prevent it from bubbling up

        var dealerID = $(this).data('id');
        $('.dealer-block-wrapper').hide();
        $('.dealer-block-wrapper[data-dealer="' + dealerID + '"]').show();
        $('#dealer-more-info').fadeIn();
        $('.js-slider').slick('setPosition');
    });  

    // Trigger next on radio select
    $(document).on('click', '.js-next .listradio-wrap input[type=radio]', function() {
        $(this).trigger( 'change' );
        $('input.nf-next').trigger('click');
        nfRadio.channel( 'nfMP' ).trigger( 'change:part', this );
    }); 

    // Function to apply clear button to Ninja Forms inputs
     function addClearButtons() {
       $('.nf-form-content input[type="text"], .nf-form-content input[type="email"]').each(function () {
         const $input = $(this);

         // Avoid duplicating
         if ($input.parent('.nf-clear-wrapper').length === 0) {
           $input.wrap('<div class="nf-clear-wrapper""></div>');
           const $btn = $('<button type="button" class="nf-clear-btn" aria-label="Clear">&times;</button>');
           $input.after($btn);

           // Show/hide button
           $input.on('input', function () {
             $btn.toggle($(this).val().length > 0);
           });

           // Clear input
           $btn.on('click', function () {
             $input.val('').trigger('input').focus();
           });
         }
       });
     }

    // Initial run
      addClearButtons();

      // Use MutationObserver to watch for form changes (e.g. AJAX load or conditional fields)
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if ($(node).find('.nf-form-content').length || $(node).hasClass('nf-form-content')) {
              addClearButtons(node);

              if (!$('.clickable.focused').length && $('.product-request-quote').length && $('#dealer-results').length) {

                  $('.product-request-quote .nf-next').prop('disabled', true);

                  // Ninja Forms error handling — find the right field to target

                  // TODO: ERROR on no dealer, no error on initial run, remove error on focus

                  const $errorField = $('.nf-field:has(#dealer-results)'); // or dealername, depending

                  // Add error class and message
                  if (!$errorField.find('.nf-error-msg').length) {
                    $errorField.addClass('nf-error');
                    $errorField.find('.nf-field-element').after('<div class="nf-error-msg">Please select a contractor from whom you would like to request a quote.</div>');
                  }
                  
              }
            }
          });
        });
      });

      // Watch body or a specific container
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

});

$(window).on('load', function() {
    var scroll = $(window).scrollTop();
    var scrollVal = 120;

    if ($(window).width() <= 1024) {
        scrollVal = 60;
    }

    if (scroll >= scrollVal) {
        $(".site-header").addClass("is-sticky");
    }
});